import {
  setEnvironmentVariables,
  setToken,
  clickInteraction,
  toggleAside,
} from '../effects/application';
import { handleEffects } from '../utils/store';

const initialState = {
  token: undefined,
  asideOpen: false,
  env: {},
};

export default handleEffects(
  {
    [setToken]: (state, action) => ({ ...state, token: action.payload.token }),
    [setEnvironmentVariables]: (state, action) => ({
      ...state,
      env: { ...action.payload },
    }),
    [clickInteraction]: (state, action) => ({
      ...state,
      lastClicked: action.payload,
    }),
    [toggleAside]: (state, action) => ({
      ...state,
      asideOpen: action.payload,
    }),
  },
  initialState,
);
